import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Fuel from '@/plugins/sdk/resources/Fuel'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'fuel_service'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      fuel: new ITEM(Fuel),
      carrier_service: new ITEM(CarrierService)
    }
  }
}
